<template>
  <div class="body__form--subscription">
    <div class="subscription__section">
      <div class="hide__subscription-section">
        <div class="card">
          <div class="card-body">
            <div class="step__voyage">
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="
                    step === 1 || step === 2 ? 'custom__badge--active' : ''
                  "
                >
                  1
                </div>
                <div
                  class="badge__text"
                  :class="
                    step === 1 || step === 2
                      ? 'badge__text--active--active'
                      : ''
                  "
                >
                  Informations
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 3 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 3 ? 'badge__text--active--active' : ''"
                >
                  Fichiers joints
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 4 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 4 ? 'badge__text--active--active' : ''"
                >
                  Résultat
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-body">
            <div class="custom__badge-section d-md-none">
              <div
                class="custom__badge_default"
                :class="step === 1 || step === 2 ? 'custom__badge--active' : ''"
              >
                1
              </div>
              <div
                class="custom__badge_default"
                :class="step === 3 ? 'custom__badge--active' : ''"
              >
                2
              </div>
              <div
                class="custom__badge_default"
                :class="step === 4 ? 'custom__badge--active' : ''"
              >
                3
              </div>
            </div>
            <h4 class="mb-4">{{ titleStep() }}</h4>
            <div v-if="step === 1">
              <div class="row">
                <div class="col-md-9 col-12">
                  <div class="form-check">
                    <label class="form-check-label form__label">
                      <input
                        type="radio"
                        v-model="form.data.type_engin"
                        class="form-check-input"
                        value="1"
                        name="materiel"
                      />Véhicules à 4 roues
                    </label>
                    <label
                      @click="changeType()"
                      class="form-check-label ml-5 form__label"
                    >
                      <input
                        type="radio"
                        v-model="form.data.type_engin"
                        class="form-check-input"
                        value="2"
                        name="materiel"
                      />Véhicules à 2 ou 3 roues
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Type de carburant</label>
                    <select
                      @change="getPuissance()"
                      v-model="form.data.fuel_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in typeCarburant"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.fuel_id" style="color: red">
                      {{ errors.fuel_id[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Puissance en chevaux</label>
                    <select v-model="form.data.power_id" class="form-control">
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in puissance"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.power_id" style="color: red">
                      {{ errors.power_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Catégorie / Usage</label>
                    <select
                      @change="getSubcategory()"
                      v-model="form.data.category_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in categories"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.category_id" style="color: red">
                      {{ errors.category_id[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Sous catégories</label>
                    <select
                      @change="getSurprime()"
                      v-model="form.data.sub_category_id"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in sub_cateogries"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.sub_category_id" style="color: red">
                      {{ errors.sub_category_id[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Nombres de places</label>
                    <input
                      v-model="form.data.number_of_seats_in_the_vehicle"
                      type="number"
                      class="form-control"
                    />
                    <div
                      v-if="errors.number_of_seats_in_the_vehicle"
                      style="color: red"
                    >
                      {{ errors.number_of_seats_in_the_vehicle[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Durée de l’abonnement</label>
                    <select
                      v-model="form.data.duration_of_insurance"
                      class="form-control"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in durations"
                        :key="key"
                        :value="item.slug"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div v-if="errors.duration_of_insurance" style="color: red">
                      {{ errors.duration_of_insurance[0] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Vénale</label>
                    <input
                      v-model="form.data.valeur_venal"
                      type="number"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_venal" style="color: red">
                      {{ errors.valeur_venal[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Neuve</label>
                    <input
                      v-model="form.data.valeur_neuve"
                      type="number"
                      class="form-control"
                    />
                    <div v-if="errors.valeur_neuve" style="color: red">
                      {{ errors.valeur_neuve[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="step === 2">
              <div class="row" v-if="surprime.length > 0">
                <div class="col-12">
                  <h6 class="font-weight-bold">
                    Surprime responsabilité civile
                  </h6>
                </div>
              </div>
              <div class="row mb-2" v-for="(item, key) in surprime" :key="key">
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        type="checkbox"
                        @click="checkSurprime(item)"
                        :disabled="item.required ? true : false"
                        :checked="
                          item.required ||
                          (form.data.semi_remorque == true &&
                            item.text.includes('Surprimes')) ||
                          (form.data.domage == true &&
                            item.text.includes('Dommages'))
                            ? true
                            : false
                        "
                      />
                      {{ item.text }}
                      <svg
                        style="cursor: pointer"
                        @click="showTooltips('hello')"
                        class="tooltips_n"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z"
                            fill="#5E5873"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z"
                            fill="#5E5873"
                          />
                          <path
                            d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z"
                            fill="#5E5873"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0.5 0.0725098)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div
                      v-if="
                        item.required ||
                        item.text.includes('Dommages') ||
                        item.text.includes('Surprimes')
                      "
                      class="surprime__section-two"
                    ></div>
                    <div
                      v-if="
                        item.required ||
                        item.text.includes('Dommages') ||
                        item.text.includes('Surprimes')
                      "
                      class="surprime__section-tree"
                    >
                      {{ getPirce(item.coast) }}
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div v-if="garuanted.length > 0" class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold">Garentie</h6>
                </div>
              </div>
              <div
                class="row mb-2"
                v-for="(item, key) in garuanted"
                :key="`el` + key"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        :class="'garuanted' + key"
                        type="checkbox"
                        :checked="
                          form.data.list_of_guarantees.includes(item.id)
                            ? true
                            : false
                        "
                        @click="checkGaruanted(item)"
                      />
                      {{ item.name }}
                      <!--
                                            <svg style="cursor: pointer" @click="showTooltips('')" class="tooltips_n" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z" fill="#5E5873"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z" fill="#5E5873"/>
                                                    <path d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z" fill="#5E5873"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="16" height="16" fill="white" transform="translate(0.5 0.0725098)"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>-->
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      {{
                        getPriceGaruanted(
                          item.amount,
                          item.percentage,
                          item.key
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step === 3">
              <p>
                Veuillez charger le(s) fichier(s) requis :
                <span style="color: #d09a12">copie de la carte grise.</span>
              </p>
              <file-upload
                ref="upload"
                :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
              />
            </div>
            <div v-if="step === 4">
              <div class="detail__sup">
                <div class="section__information">
                  <div class="section__information-text">Prime nette</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.amount) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information">
                  <div class="section__information-text">Coût de pièce</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.avenant) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__information">
                  <div class="section__information-text">Taxe</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ $format(summary.taxe) + " Fcfa" }}
                  </div>
                </div>
                <div class="section__amount">
                  <div class="section__amount-text">Total</div>
                  <div class="section__amount-price">
                    {{ $format(summary.total) + " Fcfa" }}
                  </div>
                </div>
              </div>
              <div class="section__neg" @click="saveNegotiated()">
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                    fill="#002A85"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                    fill="#002A85"
                  />
                  <path
                    d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 8.66732 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                    fill="#002A85"
                  />
                </svg>
                <span class="section__neg-text">Demander une négociation</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="button__footer">
              <button
                @click="prevStep()"
                :disabled="step === 1"
                class="btn btn-default__cancel mr-2"
              >
                Retour
              </button>
              <button
                :class="loading ? 'disabled' : ''"
                class="btn btn-primary__save"
                @click="saveAssurance()"
              >
                {{ getText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../../../helpers/shared";
import FileUpload from "../../../../../components/upload/FileUpload.vue";
let loader = null;
export default {
  components: { FileUpload },
  name: "auto",
  props: ["subscription"],
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    errors: [],
    step: 1,
    element: 0,
    loading: false,
    files: [],
    summary: {
      amount: 0,
      avenant: 0,
      affaire: 5000,
      taxe: 0,
      total: 0,
    },
    categories: [],
    typeCarburant: [
      { name: "Essence", id: 1 },
      { name: "Diesel", id: 2 },
    ],
    puissance: [],
    sub_cateogries: [],
    durations: [],
    surprime: [],
    garuanted: [],
    form: {
      amount: "",
      product_id: 1,
      step: 1,
      data: {
        type_engin: "1",
        fuel_id: "",
        power_id: "",
        category_id: "",
        sub_category_id: "",
        use_type: "",
        semi_remorque: false,
        domage: false,
        duration_of_insurance: "",
        number_of_seats_in_the_vehicle: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        valeur_venal: "",
        valeur_neuve: "",
        person_to_contact: "",
        telephone_number: "",
        vehicle_registration_card: "",
        list_of_guarantees: [],
      },
    },
  }),
  watch: {
    'form.data.duration_of_insurance': function(newValue, oldValue) {
      this.summary.avenant = newValue === '1 year' ? 5000 : 2500
    },
  },
  mounted() {
    this.initializeForm(this.subscription);
  },
  methods: {
    initializeForm(element) {
      let { amount, data, product_id, step } = element;
      if (data.type_engin == "1") {
        this.form.step = step;
        this.form.amount = amount;
        this.form.product_id = product_id;
        this.form.data = data;
        this.getCategorie();
        this.getSubcategoryMounted();
        this.getPuissance();
        this.getDurations();
      }
    },

    getSubcategoryMounted() {
      this.loading = true;
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "sub_category",
        })
        .then((response) => {
          this.loading = false;
          this.sub_cateogries = response.data;
          this.getGaruanted();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    checkSurprime(item) {
      console.log(item.text);
      if (item.text.includes("Surprimes")) {
        this.form.data.semi_remorque = !this.form.data.semi_remorque;
      }
      if (item.text.includes("Dommages")) {
        this.form.data.domage = !this.form.data.domage;
      }
    },
    getSurprime() {
      if (this.form.data.sub_category_id != "") {
        let element = this.sub_cateogries.find(
          (el) => el.id == this.form.data.sub_category_id
        );
        if (element) {
          this.surprime = element.surprime ? element.surprime : [];
        } else this.surprime = [];
      } else this.surprime = [];
    },
    showTooltips(text) {
      this.$document(".tooltips_n").tooltip({
        title: text,
        trigger: "click",
        placement: "top",
      });
    },
    getPirce(price) {
      if (price == "") {
        if (
          ["12", "13", "14", "15"].includes(
            this.form.data.number_of_seats_in_the_vehicle
          )
        ) {
          return this.$format(96300);
        }
        if (
          ["16", "17", "18", "19", "20"].includes(
            this.form.data.number_of_seats_in_the_vehicle
          )
        ) {
          return this.$format(102720);
        }
        if (this.form.data.number_of_seats_in_the_vehicle > 20) {
          return this.$format(
            102720 +
              parseInt(this.form.data.number_of_seats_in_the_vehicle - 20) *
                3900
          );
        }
      } else {
        return this.$format(price);
      }
    },
    getPriceGaruanted(price, per, key) {
      if (per == 0) {
        return this.$format(price) + " Fcfa";
      } else {
        if (key == "vv") {
          return (
            this.$format(Math.round(this.form.data.valeur_venal * price)) +
            " Fcfa"
          );
        } else {
          return (
            this.$format(Math.round(this.form.data.valeur_neuve * price)) +
            " Fcfa"
          );
        }
      }
    },

    saveNegotiated() {
      if (this.step == "3") {
        loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(
            api("subscription/negotiated/" + this.subscription.uuid),
            this.form
          )
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La demande de négociation a été enregistré",
              });
              setTimeout(() => {
                this.$router("/administration/subscriptions");
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    addBasket() {
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                this.form.amount = this.summary.total;
                data.push({
                  product: this.form,
                  detail: this.summary,
                  files: this.files,
                  check: true,
                  uuids: this.$uuid(),
                  uuid: this.subscription.uuid,
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    files: this.files,
                    check: true,
                    uuids: this.$uuid(),
                    uuid: this.subscription.uuid,
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              }
            } else this.$toasted.global.error();
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          this.form.amount = this.summary.total;
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
            uuid: this.subscription.uuid,
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
              uuid: this.subscription.uuid,
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        }
      }
    },
    saveAssurance() {
      if (this.step === 4) {
        this.addBasket();
      } else {
        if (this.step === 1 || this.step === 2) {
          loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.loading = true;
          axios
            .post(api("assurances/automobile/save"), this.form)
            .then((res) => {
              loader.hide();
              this.loading = false;
              if (res.data.status) {
                this.errors = [];
                this.summary.amount = res.data.amount;
                this.summary.taxe = Math.round(
                  (this.summary.amount + this.summary.avenant) * 0.06
                );
                this.summary.total =
                  this.summary.amount +
                  this.summary.taxe +
                  this.summary.avenant;
                if (this.surprime.length > 0 || this.garuanted.length > 0) {
                  this.nextStep();
                } else this.step = 3;
              } else this.$toasted.global.error();

              history.pushState({}, '', '/pannier')
            })
            .catch((error) => {
              loader.hide();
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.loading = false;
            });
        } else this.nextStep();
      }
    },
    nextStep() {
      if (this.step < 4) this.step++;
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      this.form.data.list_of_guarantees = [];
      if (this.step === 3) {
        this.$refs.upload.reloadView();
      }
      if (this.surprime.length > 0 || this.garuanted.length > 0) {
        if (this.step == 1) {
          this.garuanted = [];
        }
        if (this.step !== 1) this.step--;
      } else {
        if (this.step === 3) {
          this.step = 1;
        }
      }
    },
    titleStep() {
      if (this.step === 1) {
        return "Informations (Étape 1/2)";
      } else if (this.step === 2) {
        return "Informations (Étape 2/2)";
      } else if (this.step === 3) {
        return "Fichiers joints";
      } else return "Résultat";
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
        case 2:
          return "Suivant";
        case 3:
          return "Suivant";
        case 4:
          return "Ajouter au panier";
      }
    },
    checkGaruanted(item, key) {
      if (this.form.data.list_of_guarantees.includes(item.id)) {
        let index = this.form.data.list_of_guarantees.indexOf(item.id);
        this.form.data.list_of_guarantees.splice(index, 1);
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", false);
          this.$document(".garuanted" + index).prop("checked", false);
        }
      } else {
        if (item.id == "49") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "50") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "51") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "27") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "26") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "52") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "38") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "39") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "40") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "41") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "25") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "24") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "37") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "36") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "48") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "47") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
        } else if (item.id == "19") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "20") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "31") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "32") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "43") {
          let index = key + 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        } else if (item.id == "44") {
          let index = key - 1;
          this.$document(".garuanted" + index).prop("disabled", true);
          this.$document(".garuanted" + index).prop("checked", true);
        }
        this.form.data.list_of_guarantees.push(item.id);
      }
    },
    getPuissance() {
      if (this.form.data.fuel_id !== "") {
        this.loading = true;
        this.zone_section = [];
        axios
          .post(api("assurance-automobile/subscription"), {
            slug: "auto",
            fuel: this.form.data.fuel_id,
            state: "power",
          })
          .then((response) => {
            this.loading = false;
            this.puissance = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    getCategorie() {
      axios
        .post(api("assurance-automobile/subscription"), {
          type: this.form.data.type_engin,
          state: "category",
        })
        .then((response) => {
          this.loading = false;
          this.categories = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getGaruanted() {
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "garuanted",
        })
        .then((response) => {
          this.loading = false;
          this.garuanted = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getSubcategory() {
      this.loading = true;
      axios
        .post(api("assurance-automobile/subscription"), {
          category: this.form.data.category_id,
          state: "sub_category",
        })
        .then((response) => {
          this.loading = false;
          this.form.data.sub_category_id = "";
          this.sub_cateogries = response.data;
          this.getGaruanted();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    getDurations() {
      axios
        .post(api("assurance-automobile/subscription"), {
          state: "duration",
        })
        .then((response) => {
          this.loading = false;
          this.durations = response.data;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    changeType(val) {
      this.$emit("changeType", 2);
    },
  },
};
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  transform: scale(1.2);
}
.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 150px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
    align-self: center;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}

.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg {
  cursor: pointer;
}

.section__neg-text {
  color: #002a85;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .surprime__section{
        display: grid;
        grid-template-columns: 110px 2fr 110px;
        align-items: baseline;
        .surprime__section-two{
            border-bottom: 1px dotted #000000;
        }
        .surprime__section-tree{
            justify-self: end;
            color: #000000;
            font-weight: bold;
        }
        .surprime__section-first{
            color: #6E6B7B;
        }
    }*/
.surprime__section {
  display: flex;
  flex-direction: row;
}
.surprime__section-two {
  flex-grow: 2;
  border-bottom: 1px solid;
}
.surprime__section-tree {
  flex-grow: 0;
}
</style>
